<template>
  <div ref="resizable" class="resizable">
    <div ref="content" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'

@Component
export default class NResizable extends Vue {
  @Ref('resizable') resizableEl!: HTMLDivElement
  @Ref('content') contentEl!: HTMLDivElement

  resizeContainer() {
    const { top } = this.resizableEl.getBoundingClientRect()
    const { bottom } = this.contentEl.getBoundingClientRect()

    // 'bottom' is the pixel coordinate of the end of the complete rectangle (i.e. with paddings and margins) on the y-axis
    // 'top' the start of the wrapping div. Handy, because this will include all top margins/paddings of the content.
    this.resizableEl.style.height = bottom - top - 1 + 'px'
  }

  private observer!: MutationObserver
  private resizeObserver!: ResizeObserver

  mounted() {
    this.observer = new MutationObserver(() => {
      this.resizeContainer()
    })
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeContainer()
    })

    this.$nextTick(() => {
      if (this.resizableEl) {
        this.resizeContainer()
        this.observer.observe(this.contentEl, { subtree: true, childList: true, attributes: true })
        this.resizeObserver.observe(this.contentEl)
      }
    })
  }

  destroyed() {
    this.observer?.disconnect()
    this.resizeObserver?.disconnect()
  }
}
</script>

<style scoped lang="scss">
.resizable {
  transition: height 200ms ease-in-out;
  box-sizing: content-box;
}

.content {
  width: 100%;
}
</style>
